import { render, staticRenderFns } from "./ProductBagPreparation.vue?vue&type=template&id=72ab551a&scoped=true&"
import script from "./ProductBagPreparation.vue?vue&type=script&lang=js&"
export * from "./ProductBagPreparation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ab551a",
  null
  
)

export default component.exports